import React, { useState, useEffect } from "react";

import { useParams } from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';

import api from "../../services/api";
import { isRefusedInput, requestFailureMessage } from "../../services/apiError";

import { Form, Button, Alert, InputGroup, FloatingLabel } from "react-bootstrap"
import { Formik } from "formik";

import Loading from '../Shared/Loading'
import { buildSetPasswordSchema } from './setNewPassword.logic';

import styles from './Auth.module.scss';


const SetNewPassword = (props) => {
  const { t } = useTranslation();
  
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const [status, setStatus] = useState(0);
  const [initialLoading, setInitialLoading] = useState(true);
  const [initialFailed, setInitialFailed] = useState(false);

  let { token } = useParams();

  const handleLogin = async (data, form) =>  {
    //console.log(data); console.log(form);
    
    setMessage("");
    setLoading(true);

    api.post("/auth/set-password", {
      token: token,
      password: data.password
    },
      { formik: form, setErrorMessage: setMessage }
    )
      .then(response => {
        setStatus(response.data.success ? 2 : 1);
      })
      .catch((error) => {
        setLoading(false);
        if (!isRefusedInput(error))
          setMessage(requestFailureMessage(error, t));
      });
  };

  useEffect(() => {  


    function checkToken() {
      //CurrentUserService.setCurrentUser(userUid);
      api
        .post(`/auth/check-reset-token`, { token : token })
        .then((response) => {          
          setInitialLoading(false);          
          if (!response.data.success)
          {
            setInitialFailed(true)
            setStatus(-1);
          };
        })
        .catch((error) => {
          setInitialLoading(false);
          if (isRefusedInput(error)) {
            setInitialFailed(true);
            setStatus(-1);
          } else {
            // The link may be fine, so keep the form: submitting checks the token again.
            setMessage(requestFailureMessage(error, t));
          }
        });
    };

    checkToken();   

  }, [token]);

  if (initialLoading)
    return <Loading />;
  

  return (
    <>
      {initialFailed && (
        <Alert key="warning" variant="warning">
          <Trans i18nKey="setPassword.tokenInvalid">
            This password reset link is invalid or has expired. Please request a new one <Alert.Link href="/forgot-password">here</Alert.Link>.
          </Trans>
        </Alert>
      )}

      {status === 2 && (
        <Alert key="success" variant="success">
          <Trans i18nKey="setPassword.successMessage">
            The password was reset successfully.Please log in <Alert.Link href="/login">here</Alert.Link>.
          </Trans>
        </Alert>
      )}

      {status === 1 && (
        <Alert key="warning" variant="warning">
          <Trans i18nKey="setPassword.notSuccessMessage">
            Couldn't reset your password. Please request a new link to reset your password <Alert.Link href="/forgot-password">here</Alert.Link>.
          </Trans>
        </Alert>
      )}


      {status === 0 && (
        <>
          <h1 className={`mb-3 text-center ${styles.header}`}>{t('setPassword.header')}</h1>
          <Formik
            initialValues={{
              password: "",
              confirmPassword: ""
            }}
            validationSchema={buildSetPasswordSchema(t)}
            onSubmit={handleLogin}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              isValid,
              errors,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>

                <Form.Group className={styles.inputWrapper}>
                  <InputGroup>
                    <FloatingLabel controlId="validationFormik01" label={t('setPassword.password')}>
                      <Form.Control
                        type={showPass ? "text" : "password"}
                        name="password"
                        placeholder="Password"
                        value={values.password}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isInvalid={touched.password && !!errors.password}
                        className={styles.input}
                        aria-describedby="passwordRuleHint"
                      />
                    </FloatingLabel>
                    <InputGroup.Text onClick={() => setShowPass(!showPass)} className={styles.showPassIcon}>
                      <i className={showPass ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                    </InputGroup.Text>
                  </InputGroup>
                  <Form.Text id="passwordRuleHint" muted className="d-block">{t('validation.passwordHint')}</Form.Text>
                  {/* d-block: the input sits inside FloatingLabel, so Bootstrap's sibling rule cannot reveal it */}
                  {touched.password && errors.password && (
                    <Form.Control.Feedback type="invalid" className="d-block">{errors.password}</Form.Control.Feedback>
                  )}
                </Form.Group>

                <Form.Group className={styles.inputWrapper}>
                  <InputGroup>
                    <FloatingLabel controlId="validationFormik02" label={t('setPassword.confirmPassword')}>
                      <Form.Control
                        type={showConfirmPass ? "text" : "password"}
                        name="confirmPassword"
                        placeholder="Password"
                        value={values.confirmPassword}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isInvalid={touched.confirmPassword && !!errors.confirmPassword}
                        className={styles.input}
                      />
                    </FloatingLabel>
                    <InputGroup.Text onClick={() => setShowConfirmPass(!showConfirmPass)} className={styles.showPassIcon}>
                      <i className={showConfirmPass ? 'fas fa-eye-slash' : 'fas fa-eye'}></i>
                    </InputGroup.Text>
                  </InputGroup>
                  {touched.confirmPassword && errors.confirmPassword && (
                    <Form.Control.Feedback type="invalid" className="d-block">{errors.confirmPassword}</Form.Control.Feedback>
                  )}
                </Form.Group>

                <Button className={`w-100 btn-lg ${styles.submitButton}`} type="submit" disabled={loading}>
                  {loading && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  <span> {t('setPassword.set')}</span>
                </Button>
                {message && (
                  <Alert key="danger" variant="danger" className="mt-3">
                    {message}
                  </Alert>
                )}
              </Form>
            )}
          </Formik>

          <p className="mt-3 text-center">
            <Trans i18nKey="forgotPassword.goToLogin">
              or <a href="/login">go back</a> to the login page
            </Trans>
          </p>
        </>)}

    </>    
  );
}

export { SetNewPassword };